import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Consumer from "./consumer";
import Backoffice from "./backoffice";
import * as ACTIONS from "../../constants/actions";
import AuthorisedFor from "../../utils/authorisedFor";
import UnAuthorised from "./UnAuthorised";
import routes from "../../../routes";
import LabModuleApp from "./labs";
import HederaVerificationPortal from "../publicApp/HederaVerificationPortal";
import ReportVerificationById from "../publicApp/HederaVerificationPortal/ReportVerificationbyID";
import ReportVerificationByPdfUpload from "../publicApp/HederaVerificationPortal/ReportVerificationByPdfUpload";
import ReportVerification from "../publicApp/HederaVerificationPortal/ReportVerification";

const AuthenticatedApp = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        // overflowY: "hidden",
      }}
    >
      <Switch>
        <Route path="/bo">
          <AuthorisedFor
            action={ACTIONS.ACCESS_ADMIN_PORTAL}
            yes={<Backoffice />}
            no={<Redirect to={routes.dashboard} />}
          />
        </Route>
        <Route path="/labPortal">
          <AuthorisedFor
            action={ACTIONS.ACCESS_LAB_PORTAL}
            yes={<LabModuleApp />}
            no={<UnAuthorised />}
          />
        </Route>
        {/* <Route
          path={"/result-validator/upload-report/:hash"}
          component={ReportVerification}
        />
        <Route
          path={"/result-validator/upload-report"}
          component={ReportVerificationByPdfUpload}
        />
        <Route
          path={"/result-validator/search/:id"}
          component={ReportVerificationById}
        />
        <Route
          path={"/result-validator/search"}
          component={ReportVerificationById}
        />
        <Route
          path={"/result-validator/:id"}
          component={HederaVerificationPortal}
        />
        <Route
          path={"/result-validator/"}
          component={HederaVerificationPortal}
        /> */}
        <Route path="/">
          <AuthorisedFor
            action={ACTIONS.ACCESS_ADMIN_PORTAL}
            //yes={<Consumer />}
            yes={<Redirect to={routes.backOffice.orders.list} />}
            no={
              <AuthorisedFor
                action={ACTIONS.ACCESS_ADMIN_PORTAL}
                yes={<Redirect to={routes.backOffice.dashboard} />}
                no={
                  <AuthorisedFor
                    action={ACTIONS.ACCESS_LAB_PORTAL}
                    yes={<Redirect to={routes.labs.dashboard} />}
                    no={<UnAuthorised />}
                  />
                }
              />
            }
          />
        </Route>
      </Switch>
    </div>
  );
};

export default AuthenticatedApp;
